import {Box, TableCell, TableRow} from '@mui/material'

const ShimmerTableRow = ({columnCount = 7, firstColumnWidth}) => {
  return (
    <TableRow className="shimmer-row" data-testid="shimmer-row">
      <TableCell
        sx={{
          ...(firstColumnWidth
            ? {
                width: firstColumnWidth,
                minWidth: firstColumnWidth,
                maxWidth: firstColumnWidth,
              }
            : {}),
          padding: '8px',
        }}
      >
        <Box className="shimmer-content" sx={{width: 20, height: 20, borderRadius: '4px'}} />
      </TableCell>
      {Array.from({length: columnCount - 1}).map((_, index) => (
        <TableCell key={index}>
          <Box className="shimmer-content" sx={{width: '100%'}} />
        </TableCell>
      ))}
    </TableRow>
  )
}

export default ShimmerTableRow
